<div :class="embedded ? '' : 'entity-config-page container-fluid px-0 py-0 py-lg-1'">
  <div :class="embedded ? '' : 'entity-config-shell d-flex flex-column gap-3 mx-auto'">
    <section v-if="!embedded" class="entity-config-top rounded-4 overflow-hidden shadow-sm">
      <div class="entity-config-top-hero px-2 px-md-3 py-3">
        <div class="row g-2 align-items-start flex-nowrap">
          <div class="col">
            <h1 class="entity-page-title text-white fw-bold lh-sm mb-1">
              {{ verification_form_name ? `${verification_form_name} — question mapping` : 'Question mapping' }}
            </h1>
            <p class="entity-page-subtitle text-white mb-0">
              Match each onboarding question to its verification equivalent.
            </p>
          </div>

          <div class="col-auto d-flex justify-content-end align-items-start gap-2">
            <button
              v-if="(verification_questions || []).length"
              type="button"
             class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
              @click.prevent="save_mappings"
              :disabled="saving"
            >
              <span class="spinner-border spinner-border-sm me-2" v-if="saving" role="status" aria-hidden="true"></span>
              <i class="bi bi-check2-circle me-1" v-else></i>
              Save
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="card border border-purple border-opacity-50 shadow-sm rounded-4 overflow-hidden bg-white">
      <div v-if="embedded" class="px-3 px-md-4 py-3">
        <div class="d-flex flex-wrap align-items-start align-items-md-center gap-2">
          <div class="min-w-0">
            <div class="fw-bold text-x mb-0">Question mapping</div>
            <div class="text-secondary text-xs">Map each onboarding question to a verification question.</div>
          </div>

         <button
          v-if="(verification_questions || []).length"
          type="button"
          class="btn entity-assign-btn btn-sm rounded-3 fw-semibold px-4 py-2 ms-md-auto"
          @click.prevent="save_mappings"
          :disabled="saving"
         >
         <span class="spinner-border spinner-border-sm me-2" v-if="saving" role="status" aria-hidden="true"></span>
         <span>Save</span>
         </button>
        </div>
      </div>

      <div v-if="!empty_state" class="form-mapping-header px-3 px-md-4 py-2">
        <div class="row g-2 align-items-center text-xxs text-uppercase fw-bold text-secondary">
          <div class="col-5 d-flex align-items-center gap-2">
            <i class="bi bi-patch-check"></i>
            <span>Verification form question</span>
          </div>
          <div class="col-2 text-center">
            <i class="bi bi-arrow-left-right"></i>
          </div>
          <div class="col-5 d-flex align-items-center gap-2">
            <i class="bi bi-journal-text"></i>
            <span>Onboarding form question</span>
          </div>
        </div>
      </div>

      <div class="card-body p-0">
        <div v-if="loading" class="p-4 text-secondary text-xs d-flex align-items-center gap-2">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span>Loading questions...</span>
        </div>

        <div v-else-if="loading_existing_mappings" class="px-3 px-md-4 py-2 text-secondary text-xs d-flex align-items-center gap-2 border-bottom">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span>Loading saved mappings...</span>
        </div>

        <div v-else-if="empty_state" class="p-4 p-md-5 text-center">
          <div class="rounded-circle bg-warning-subtle text-warning d-inline-flex align-items-center justify-content-center mb-3 p-3 lh-1">
            <i class="bi bi-exclamation-triangle fs-4"></i>
          </div>
          <div class="fw-semibold text-x mb-1">{{ empty_state.title }}</div>
          <div class="text-secondary text-xs mb-3">{{ empty_state.description }}</div>
          <button
            v-if="empty_state.action_event"
            type="button"
            class="btn btn-light btn-sm rounded-3 text-xs px-3 d-inline-flex align-items-center gap-2"
            @click="$emit(empty_state.action_event)"
          >
            <i class="bi bi-box-arrow-up-right"></i>
            <span>{{ empty_state.action_label }}</span>
          </button>
        </div>

        <div
          v-else
          class="d-flex flex-column gap-3 px-3 px-md-4 py-3"
          :class="(verification_questions || []).length > 5 ? 'form-mapping-scroll' : ''"
        >
          <div v-for="question in verification_questions" :key="question.id" class="border-0">
            <div class="row g-2 align-items-center">
              <div class="col-12 col-md-5">
                <input
                  type="text"
                  class="form-control form-control-sm rounded-3 text-xs bg-white form-mapping-input"
                  :value="question.label"
                  disabled
                  readonly
                />
              </div>

              <div class="col-12 col-md-2 text-center">
                <div class="d-inline-flex align-items-center justify-content-center form-mapping-arrow">
                  <i class="bi bi-arrow-right"></i>
                </div>
              </div>

              <div class="col-12 col-md-5">
                <div class="d-flex align-items-center gap-2">
                  <div class="flex-grow-1 position-relative">
                    <div class="form-mapping-select-shell border rounded-3 bg-white p-2"
                      :class="verification_to_onboarding?.[String(question.id)] ? 'is-mapped border-primary' : 'is-unmapped border-secondary-subtle'">
                      <select
                        class="form-select form-select-sm border-0 p-1 form-mapping-select text-xs fw-normal"
                        :value="verification_to_onboarding[String(question.id)] || ''"
                        :disabled="loading || loading_existing_mappings || saving"
                        @change="on_change_onboarding_selection(question.id, $event.target.value)"
                      >
                        <option :value="''">Select a question...</option>
                        <option v-for="option in onboarding_questions" :key="option.id" :value="option.id">
                          {{ option.label }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <span class="form-mapping-status flex-shrink-0"
                    :class="verification_to_onboarding?.[String(question.id)] ? 'is-mapped' : 'is-unmapped'"
                    title="Mapping status">
                    <i class="bi bi-check2" v-if="verification_to_onboarding?.[String(question.id)]"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="!empty_state && (verification_questions || []).length"
        class="form-mapping-footer px-3 px-md-4 py-2 d-flex align-items-center gap-2 text-secondary text-xxs"
      >
        <i class="bi bi-info-circle"></i>
        <span>Map each onboarding question to a verification question.</span>
        <span class="ms-auto fw-bold">{{ mapped_count }}/{{ (verification_questions || []).length }} mapped</span>
      </div>
    </section>
  </div>
</div>
